var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:!_vm.loaded ? {'skeleton-box': true} : _vm.classNamesBox,style:(!_vm.loaded ? _vm.loadingStyles : {})},[_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.loaded),expression:"loaded"}],class:_vm.classNames,attrs:{"src":_vm.srcImg,"srcset":_vm.srcSet,"alt":_vm.title},on:{"load":function($event){return _vm.imgLoad()}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }